import { Text } from "@clipboard-health/ui-components";
// eslint-disable-next-line no-restricted-imports
import { Slider, Stack, useTheme } from "@mui/material";

interface InstantPaySliderProps {
  payoutAmount: number;
  totalPay: number;
  billValue: number;
  onSliderChange: (_event: Event, value: number | number[]) => void;
}

export function InstantPaySlider(props: InstantPaySliderProps) {
  const { payoutAmount, totalPay, billValue, onSliderChange } = props;
  const theme = useTheme();

  return (
    <Stack spacing={1} sx={{ marginTop: 2 }}>
      <Slider
        value={payoutAmount}
        min={0}
        max={totalPay}
        step={billValue}
        thumb="true"
        sx={{
          color: theme.palette.text.primary,
          paddingX: "0 !important",
        }}
        onChange={onSliderChange}
      />
      <Stack direction="row" justifyContent="space-between">
        <Text variant="caption" sx={{ color: theme.palette.text.secondary }}>
          $0
        </Text>
        <Text variant="caption" sx={{ color: theme.palette.text.secondary }}>
          ${totalPay.toFixed(2)}
        </Text>
      </Stack>
    </Stack>
  );
}
